import { callEndpointWithRetry } from './apiUtils';
import 'whatwg-fetch';

export const joinChatApi = async (jwt: string, retryCount = 4): Promise<JoinChatSuccessResponse> => {
  const {
    APPINSTANCEUSERARN,
    ACCESSKEYID,
    SECRETACCESSKEY,
    SESSIONTOKEN,
    EXPIRATION,
    CHANNELARN,
  }: JoinChatSuccessResponse = await callEndpointWithRetry('join-chat', jwt, 'POST', retryCount);

  return { APPINSTANCEUSERARN, ACCESSKEYID, SECRETACCESSKEY, SESSIONTOKEN, EXPIRATION, CHANNELARN };
};
